export default "assets/facebook-big-c5520bb7.svg";